module.exports = __webpack_public_path__ + "img/cefori-01.0ef49272.svg";